import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import {Row} from 'reactstrap'
import {authenticationHelpers} from "../../../dataHelpers"
import {pageHelpers} from '../'
import {RequestPasswordResetForm, SetNewPasswordForm} from "../../ui"
import '../../../stylesheets/Authentication.css'


class ForgotPasswordPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)

        let oneTimeLink = this.queryParams.c
        let userID = this.queryParams.u
        let expired = false
        if (this.queryParams.e) {
            let expireTime = parseInt(this.queryParams.e)
            let now = Math.round((new Date()).getTime() / 1000)
            expired = (now >= expireTime)
        }

        this.state = {
            expired: expired,
            oneTimeLink: oneTimeLink,
            userID: userID,
            userConfirmationRequests: [],
            errors: []
        }

        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)

        let oneTimeLink = this.queryParams.c
        let userID = this.queryParams.u
        let expired = false
        if (this.queryParams.e) {
            let expireTime = parseInt(this.queryParams.e)
            let now = Math.round((new Date()).getTime() / 1000)
            expired = (now >= expireTime)
        }

        this.setState({
            expired: expired,
            oneTimeLink: oneTimeLink,
            userID: userID
        })
    }

    componentWillMount() {
        pageHelpers.setupSingleRunAnimationEvents()
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    async handleValidSubmit(event, values) {
        event.preventDefault()

        let {userID, oneTimeLink} = this.state

        if (userID && oneTimeLink) {
            let {password} = values
            let response = await authenticationHelpers.setNewPassword(userID, oneTimeLink, password, this.history)
            if (response.error) {
                this.setState({errors: [response.error]})
            } else if (response.confirmationRequest) {
                this.setState({userConfirmationRequests: [response.confirmationRequest]})
            }
        } else {
            let {email} = values
            let response = await authenticationHelpers.getPasswordReset(email, this.history)
            if (response.error) {
                this.setState({errors: [response.error]})
            } else if (response.confirmationRequest) {
                this.setState({userConfirmationRequests: [response.confirmationRequest]})
            }
        }
    }

    render() {
        let {expired, oneTimeLink, userID, errors, userConfirmationRequests} = this.state

        return <Row className="justify-content-center">
            {expired ?
                <div className="text-center">
                    <h1>This link has expired.</h1>
                    <h2><Link to="/forgot">Click here to send a new password reset email.</Link></h2>
                </div> :
                (oneTimeLink && userID ?
                    <SetNewPasswordForm onValidSubmit={this.handleValidSubmit}
                                          onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}/> :
                    <RequestPasswordResetForm onValidSubmit={this.handleValidSubmit}
                                                 onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}/>)}


            {pageHelpers.renderErrorModalsForPage(errors, this)}
            {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}
        </Row>
    }
}

export default withRouter(ForgotPasswordPage)



// WEBPACK FOOTER //
// ./src/components/pages/authentication/ForgotPasswordPage.js